import { render, staticRenderFns } from "./GzhBtnEdit.vue?vue&type=template&id=a90dc73a&scoped=true"
import script from "./GzhBtnEdit.vue?vue&type=script&lang=js"
export * from "./GzhBtnEdit.vue?vue&type=script&lang=js"
import style0 from "./GzhBtnEdit.vue?vue&type=style&index=0&id=a90dc73a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90dc73a",
  null
  
)

export default component.exports